<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-hand-holding-water" id="ico"></i>
		<h1 style="display: inline-block;">Macromedidor</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row" *ngIf="datos">
			<div class="col col-sm-12 col-md-7 col-lg-7 contenido">
				<i style="margin-right: 3px;" class="fal fa-barcode-alt col-md-1"></i><b>IMEI:</b>&nbsp;{{datos.imei}}<br>
				<i style="margin-right: 3px;" class="fal fa-barcode-alt col-md-1"></i><b>Descripcion:</b>
				{{datos.descripcion}}<br>
				<i style="margin-right: 3px;" class="fal fa-tint col-md-1"></i><b>Gasto:</b>&nbsp;{{datos.gasto | number:
				'1.4-4'}} m3/h<br>
				<i style="margin-right: 3px;" class="fal fa-hand-holding-water col-md-1"></i><b>Totalizador:</b>&nbsp;
				{{datos.totalizador | number: '1.4-4'}} m3<br>
				<i style="margin-right: 3px;" class="fal fa-toggle-on col-md-1"></i><b>Estatus:</b>&nbsp;
				{{datos.estatus}}<br>
				<i style="margin-right: 3px;" class="fal fa-weight col-md-1"></i><b>Modelo:</b>&nbsp;{{datos.modelo}}<br>
				<i style="margin-right: 3px;" class="fal fa-draw-polygon col-md-1"></i><b>Geocerca:</b>
				{{geocercaAsignada}}<br>
				<i style="margin-right: 3px;" class="fal fal fa-calendar-alt col-md-1"></i><b>Fecha y
					hora:</b>&nbsp;{{fecha}}&nbsp;{{hora}}<br>
				<i style="margin-right: 3px;" class="fal fa-building col-md-1"></i><b>Cliente:</b>&nbsp;{{datos.cliente}}<br>
				<i style="margin-right: 3px;" class="fal fa-map-pin col-md-1"></i><b>Direccion:</b>&nbsp;{{direccion}}<br>
				<i style="margin-right: 3px;" class="fas fa-faucet col-md-1"></i>
			</div>
			<div class="col col-sm-12 col-md-5 col-lg-5 contenido">
				<img [src]="imagen" style="width: 100%;" loading="lazy">
			</div>
		</div>
		<div class="row">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button class="btnPopup ubicar mt-3" mat-raised-button (click)="ubicarMedidor()"><i id="btnIco"
						class="fal fa-binoculars"></i>&nbsp;Ubicar</button>&nbsp;
				<button class="btnPopup historico mt-3" mat-raised-button (click)="verHistorico()"><i id="btnIco"
						class="fal fa-calendar-alt"></i>&nbsp;Histórico</button>&nbsp;
				<button class="btnPopup streetView mt-3" mat-raised-button (click)="verCalle()"><i id="btnIco"
						class="fal fa-street-view"></i>&nbsp;Street View</button>&nbsp;
			</div>
		</div>
	</div>
</div>
